import React, { FC, useEffect } from 'react';
import { Box, Grid } from '@mui/material';

import { PharmacistLegendVariant, PharmacyLegendVariant, WorkshiftStatus } from '@pharmaplan/common';
import { stub } from '@pharmaplan/common/helpers/utils';

import { nameTypes } from '../SelfService/Workshifts/WorkshiftForm/ViewEditContract/ViewEditContractTime/ViewEditContractTime';
import ViewEditContractDate from '../SelfService/Workshifts/WorkshiftForm/ViewEditContract/ViewEditContractDate';
import DateBox from '../SelfService/Workshifts/WorkshiftForm/ViewEditContract/ViewEditContractTime/DateBox';
import useMultiShiftDelete from '../../hooks/MultiShiftDelete/useMultiShiftDelete';
import LongTermModalLayout from '../common/LongTermModalLayout';
import { getDayMonthDateYear } from '../Reports/helpers';
import CustomCheckbox from '../common/CustomCheckbox';
import CustomChip from '../common/CustomChip';
import strings from '../../localization';

import styles from './styles';
import { serverToday } from '../../helpers/Functions';
import { ChipType } from '../../helpers/Constants';

interface IMultiShiftDelete {
  longTermShiftContractId: string;
}

const MultiShiftDelete: FC<IMultiShiftDelete> = ({ longTermShiftContractId }) => {
  const {
    handleSubmit,
    handleCheckboxClick,
    formik,
    handleClose,
    selectedIds,
    handleSelectAll,
    getAPI,
    isAllSelected,
    startDate: openedDate,
    data,
  } = useMultiShiftDelete({ longTermShiftContractId });

  useEffect(() => {
    getAPI();
  }, []);

  const statusConfig = {
    [WorkshiftStatus.Booked]: {
      type: PharmacyLegendVariant.booked,
      label: strings.booked,
    },
    [WorkshiftStatus.NotAvailable]: {
      type: PharmacyLegendVariant.booked,
      label: strings.booked,
    },
    [WorkshiftStatus.Requested]: {
      type: PharmacistLegendVariant.requested,
      label: strings.requested,
    },
    [WorkshiftStatus.Posted]: {
      type: PharmacistLegendVariant.workshift,
      label: strings.posted,
    },
  };

  return (
    <LongTermModalLayout
      primary={{
        label: strings.delete,
        onPress: handleSubmit,
        disabled: !selectedIds?.length,
      }}
      secondary={{ label: strings.close, onPress: handleClose }}
    >
      <Grid md={5} xs={12} item>
        <ViewEditContractDate
          sync
          openedDate={openedDate}
          formik={formik}
          onDateChange={stub}
          isUpdate
        />
      </Grid>
      <Grid md={7} xs={12} item>
        <Box>
          <CustomCheckbox
            label={strings.selectAll}
            name="selectAll"
            handleChange={handleSelectAll}
            value={isAllSelected}
            id="selectAll"
          />
        </Box>
        <Box sx={styles.dateBoxGrid}>
          {data?.map?.((interval) => {
            let Chip;

            const { startDate = '', status } = interval ?? {};
            const { label, type: chipType } = statusConfig?.[status as keyof typeof statusConfig] ?? {};

            const date = startDate?.split?.('T')?.[0];
            const showUnfulfilled = startDate
                          < (serverToday()?.toISO({ includeOffset: false }) ?? '')
                        && (status !== WorkshiftStatus.Booked);

            if (showUnfulfilled) {
              Chip = (
                <CustomChip
                  type={ChipType.notAvailable}
                  label={strings.unfulfilled}
                />
              );
            } else {
              Chip = (
                <CustomChip
                  type={chipType}
                  label={label}
                />
              );
            }

            const showCheckbox = showUnfulfilled || status === WorkshiftStatus.Booked;

            return (
              <DateBox
                Chip={Chip}
                key={date}
                checkboxValue={selectedIds?.includes(interval?.workShiftId ?? '')}
                handleCheckboxClick={handleCheckboxClick(interval?.workShiftId ?? '')}
                showCheckbox={!showCheckbox}
                changedName={`${date}|${nameTypes.changed}`}
                title={`${getDayMonthDateYear(date)}`}
                startName={`${date}|${nameTypes.start}`}
                endName={`${date}|${nameTypes.end}`}
                formik={formik}
                hideDayOff
                disabled
                dayOffName=""
              />
            );
          })}
        </Box>
      </Grid>
    </LongTermModalLayout>
  );
};

export default MultiShiftDelete;
